export const pallete = {
    LightGray: "#ccc",
    Gray:"rgb(40, 40, 40);",
    White:"#FFFFFF",
    BackGround: "#1b1b1b",
    BackGroundOpacity: "rgb(27, 27, 27, 0.9)",
    LogoBlue: "#3c81c0",
    LogoPink :"#e43253",
    LogoOrange: "#ef9824",
}